<div class="headerdiv">
    <div >
      <h3 class="pagetitle">User Management</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  <mat-card [formGroup]="usersForm" class="addadmin">
      <label class="inviteuser">Invite User</label>
  <div class="row">
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="first_name" matInput placeholder="First Name">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="last_name" matInput placeholder="Last Name">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <input formControlName="email" matInput placeholder="Email">
          </mat-form-field>
      </div>
  </div>
  <button (click)="sendInv()" mat-flat-button color="primary">Send Invitation</button>
</mat-card>



<div style="font-size: 10px" class="container tablecontainer">
  <div class="row">

    <div class="search">
      <label for="search">Search for User</label>

      <div class="md-form">
        <input style="border: 1px solid #5d2041;"
          type="text"
          [(ngModel)]="searchText"
          class="form-control"
          id="search"
          mdbInput
        />
      </div>
    </div>
  </div>

  <table mdbTable #usersTable="mdbTable" class="z-depth-1">
    <thead style="background-color: #5d2041; color: white;">
      <tr>
        <th
          *ngFor="let head of headElements; let i = index"
          aria-controls="tableSortExample" 
          scope="col" 
          [mdbTableSort]="usersList" 
          [sortBy]="headElements[i]"
        >
          {{head | titlecase}}
        </th>
        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let el of usersList; let i = index">
        <th *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex"
          scope="row">{{usersList[i].first_name +" "+ usersList[i].last_name}}</th>
          
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{usersList[i].email}}</td>
        <!-- <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{usersList[i].country}}</td> -->
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">{{usersList[i].block}}</td>
        <td *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">
          <button *ngIf="usersList[i].block == active" style="margin-left: 5px;" mat-raised-button (click)="block(usersList[i].id)" >Block</button>
          <button *ngIf="usersList[i].block == blocked" style="margin-left: 5px;" mat-raised-button (click)="block(usersList[i].id)">Unblock</button>
        <button style="margin-left: 5px;" mat-raised-button (click)="promoteUser(usersList[i].id)">Promote</button>
        </td>

      </tr>
        <td colspan="4">
          <mdb-table-pagination [tableEl]="usersTable" [searchDataSource]="usersList"></mdb-table-pagination>
        </td>
    </tbody>
  </table>
</div>